const state = {
  confObjCode: {
    form: {
      type: '',
      size: {}
    },
    material: {
      type: '',
      color: ''
    },
    rand: {
    },
    note: '',
    hohlsaum: false,
    drehverschluss: false,
    quantity: 1
  },
  confObjName: {
    form: {
      type: '',
      size: {}
    },
    material: {
      type: '',
      color: ''
    },
    rand: {
    },
    note: '',
    hohlsaum: false,
    drehverschluss: false,
    quantity: 1
  },
  confObjCodeList: [],
  confObjNameList: []
}

const mutations = {
  'SET_CONFOBJ_CODE' (state, obj) {
    state.confObjCode.form.type = obj.formType
    state.confObjCode.form.size = {}
    state.confObjCode.form.size = obj.formSize
    state.confObjCode.material.type = obj.materialType
    state.confObjCode.material.color = obj.color
    state.confObjCode.rand = {}
    obj.rand.forEach(el => {
      state.confObjCode.rand[el.title] = {}
      state.confObjCode.rand[el.title].type = el.type.code
      if ('confCode' in el) {
        for (const key in el.confCode) {
          state.confObjCode.rand[el.title][key] = el.confCode[key]
        }
      }
    })
    state.confObjCode.note = obj.note
    state.confObjCode.hohlsaum = obj.hohlsaum
    state.confObjCode.drehverschluss = obj.drehverschluss
  },
  'SET_CONFOBJ_NAME' (state, obj) {
    state.confObjName.form.type = obj.formType
    state.confObjName.form.size = {}
    state.confObjName.form.size = obj.formSize
    state.confObjName.material.type = obj.materialType
    state.confObjName.material.color = obj.color
    state.confObjName.rand = {}
    obj.rand.forEach(el => {
      state.confObjName.rand[el.title] = {}
      state.confObjName.rand[el.title].type = el.type.name
      if ('conf' in el) {
        for (const key in el.conf) {
          state.confObjName.rand[el.title][key] = el.conf[key]
        }
      }
    })
    state.confObjName.note = obj.note
    state.confObjName.hohlsaum = obj.hohlsaum
    state.confObjName.drehverschluss = obj.drehverschluss
  },
  'ADD_CONFOBJ' (state) {
    state.confObjCodeList.push(JSON.parse(JSON.stringify(state.confObjCode)))
    state.confObjNameList.push(JSON.parse(JSON.stringify(state.confObjName)))
  },
  'REMOVE_CONFOBJ' (state, index) {
    state.confObjCodeList.splice(index, 1)
    state.confObjNameList.splice(index, 1)
  },
  'ADD_QUANTITY' (state, obj) {
    obj.forEach((el, index) => {
      state.confObjCodeList[index].quantity = el.quantity
      state.confObjNameList[index].quantity = el.quantity
    })
  }
}

const actions = {
  setConfObj: ({ commit }, obj) => {
    commit('SET_CONFOBJ_CODE', obj.code)
    commit('SET_CONFOBJ_NAME', obj.name)
    commit('ADD_CONFOBJ')
  },
  addQuantity: ({ commit }, obj) => {
    commit('ADD_QUANTITY', obj)
  },
  removeConfObj: ({ commit }, index) => {
    commit('REMOVE_CONFOBJ', index)
  }
}

const getters = {
  confObjCode: state => {
    return state.confObjCode
  },
  confObjName: state => {
    return state.confObjName
  },
  confObjCodeList: state => {
    return state.confObjCodeList
  },
  confObjNameList: state => {
    return state.confObjNameList
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
